export default {
    // views
    configurationList : require('./templates/configurationList.html'),
    configurationItem : require('./templates/configurationItem.html'),
    optionGroupList : require('./templates/optionGroupList.html'),
    optionDetail : require('./templates/optionDetail.html'),
    skuItemDetails : require('./templates/skuItemDetails.html'),

    priceModuleSku : require('./templates/modules/priceModuleSku.html'),
    priceModuleSkuNoCommerce : require('./templates/modules/priceModuleSkuNoCommerce.html'),
    priceModuleSkuList : require('./templates/modules/priceModuleSkuList.html'),
    priceModuleEmpty : require('./templates/modules/priceModuleEmpty.html'),
    priceBreakdownModule : require('./templates/modules/priceBreakdownModule.html'),

    productImageModule : require('./templates/modules/productImageModule.html'),
    promotionModule : require('./templates/modules/promotionModule.html'),

    validationError : require('./templates/validationError.html')
}
